import React, { useState, useEffect } from "react";
import Header from "../Header";
import Sidebar from "../SideBar";

const Home = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [changeColor, setChangeColor] = useState(false);

	const toggle = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		const changeNavbarColor = () => {
			if (window.scrollY >= 120) {
				setChangeColor(true);
			} else {
				setChangeColor(false);
			}
		};
		window.addEventListener("scroll", changeNavbarColor);
	}, []);

	return (
		<>
			<Sidebar
				isOpen={isOpen}
				toggle={toggle}
				changeColor={changeColor}
			/>
			<Header toggle={toggle} changeColor={changeColor} />
		</>
	);
};

export default Home;
